const Typography = () => `
    --sans-font: 'Helvetica Neue', 'HelveticaNeue', Helvetica, Arial, ArialMT,
    sans-serif;
    --serif-font: 'Lucida Bright', 'LucidaBright', Georgia, serif;

    --primary-font: 'Source Sans Pro', var(--sans-font);
`;

export default Typography;
